<template>
  <div id="app" class="flex flex-col h-full min-h-screen bg-gray-50">
    <Navbar/>
    <Toastr ref="toastrRef" />
    <div class="flex flex-1">
      <router-view/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import Toastr from '@/components/Toastr'
import User from '@/services/User.service';

export default {
  name: 'App',
  components: {
    Navbar, Footer, Toastr
  },
  beforeCreate(){
    this.$store.state.axiosInstance = User.getAxiosInstance();
  },
  async mounted(){
    this.$store.state.toastr = this.$refs.toastrRef;
  },
  methods: {
    
  }
  
}
</script>

<style>
 .pagination-container{
    text-align: center;
    font-size: 17px;
    display: inline-block;
    width: 100%;
  }

  .pagination-container li:first-child, .pagination-container li:last-child{
    margin: 5px;
    display: inline-block;
  }

  .page-item {
    border: 1px solid rgb(0, 0, 0);
    margin: 0px 1px;
    display: inline-block;
  }
  .pagination-container a{
    display: inline-block;
    padding: 5px 15px;
    color: #000;
  }
  .page-item.active {
    background-color: rgb(0, 0, 0);
  }

  .page-item.active a{
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue